// @flow
import React from "react";
import styled from "styled-components";
import { Spinner, Warning } from "@nested/ui/icons";

const Wrapper = styled.div`
  position: absolute;
  bottom: 10px;
  right: 20px;
  z-index: 2;
`;

type Props = {
  loading?: boolean,
  warning?: boolean,
};

const StatusIcon = ({ loading, warning }: Props) => {
  if (loading) {
    return (
      <Wrapper>
        <Spinner />
      </Wrapper>
    );
  }

  if (warning) {
    return (
      <Wrapper>
        <Warning />
      </Wrapper>
    );
  }
  return null;
};

export default StatusIcon;
